export default function PHP_const() {
  return (
    <div>
      <h1>PHP_const</h1>
    </div>
  );
}
